import { createContext } from "react";
import { Route, Routes } from "react-router-dom";
import { Status404 } from "../../modules/statusPage/component/Status404";
import { TransactionRecord } from "../../modules/transactionRecord/components/TransactionRecord";
export const TransactionRecordContext = createContext({});

export const TransactionRecordWrapper = () => {
  const value = {};

  return (
    <TransactionRecordContext.Provider value={value}>
      <Routes>
        <Route path="" element={<TransactionRecord />} />
        <Route path="*" element={<Status404 />} />
      </Routes>
    </TransactionRecordContext.Provider>
  );
};
